import { useQuery } from '@tanstack/react-query';
import { useState, useEffect } from 'react';
import type { SearchEntityType, SearchResponse } from '@peles/shared';
import { searchEntities } from '../api/search';

export function useSearch(type: SearchEntityType, debounceMs = 300) {
  const [inputValue, setInputValue] = useState('');
  const [debouncedQuery, setDebouncedQuery] = useState('');

  useEffect(() => {
    if (!inputValue.trim()) {
      setDebouncedQuery('');
      return;
    }
    const timer = setTimeout(() => {
      setDebouncedQuery(inputValue.trim());
    }, debounceMs);
    return () => clearTimeout(timer);
  }, [inputValue, debounceMs]);

  const query = useQuery<SearchResponse>({
    queryKey: ['search', type, debouncedQuery],
    queryFn: () => searchEntities(type, debouncedQuery),
    enabled: debouncedQuery.length > 0,
    staleTime: 30_000,
  });

  return {
    inputValue,
    setInputValue,
    results: query.data?.results ?? [],
    isLoading: query.isFetching,
    debouncedQuery,
  };
}
